import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import Select from "react-dropdown-select";

const NewWaterLow = ({ onCancel, onSubmit }) => {
    const [model, setModel] = useState({
        malNutrition: {},
        specialRisk: {
            tissue: "",
            neurology: [],
            major: "",
            medication: "Nil",
        },
    });
    const [confirm, setConfirm] = useState(false);

    const options = {
        tissue: [
            { value: "1", label: "Terminal Cachexia" },
            { value: "2", label: "Multiple Organ Failure" },
            { value: "3", label: "Single Organ Failure (Resp, Renal, Cardiac)" },
            { value: "4", label: "Peripheral Vascular Disease" },
            { value: "5", label: "Anaemia (HB < 8)" },
            { value: "6", label: "Smoking" },
        ],
        major: [
            { value: "1", label: "Orthopaedic/Spinal" },
            { value: "2", label: "On Table > 2 hrs **" },
            { value: "3", label: "On Table > 6 hrs **" },
        ],
    };

    const onMoreChange = (value) => {
        if (value) {
            let found = false;

            const _model = { ...model };
            for (let index = 0; index < _model.specialRisk.neurology.length; index++) {
                if (value === _model.specialRisk.neurology[index]) {
                    found = true;
                    // remove
                    _model.specialRisk.neurology.splice(index, 1);
                }
            }
            if (!found) {
                _model.specialRisk.neurology.push(value);
            }
            setModel(_model);
        }
    };
    return (
        <>
            <Helmet>
                <title>New Waterlow Pressure Ulcer Prevention| {AppName}</title>
            </Helmet>
            <form
                onSubmit={(evt) => {
                    evt.preventDefault();
                    onSubmit({ model, confirm });
                }}
            >
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Sex and Age</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "75%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "10%" }}>
                                    <strong>Score</strong>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Sex*</strong>
                                </td>
                                <td>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, sex: "Male" })} type="radio" className="custom-control-input" name="sex" id="male" />
                                        <label className="custom-control-label" htmlFor="male">
                                            Male
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, sex: "Female" })} type="radio" name="sex" className="custom-control-input" id="female" />
                                        <label className="custom-control-label" htmlFor="female">
                                            Female
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Age*</strong>
                                </td>
                                <td>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, age: "14 - 49" })} type="radio" className="custom-control-input" name="age" id="14 - 49" />
                                        <label className="custom-control-label" htmlFor="14 - 49">
                                            14 - 49
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, age: "50 - 64" })} type="radio" name="age" className="custom-control-input" id="50 - 64" />
                                        <label className="custom-control-label" htmlFor="50 - 64">
                                            50 - 64
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, age: "65 - 74" })} type="radio" name="age" className="custom-control-input" id="65 - 74" />
                                        <label className="custom-control-label" htmlFor="65 - 74">
                                            65 - 74
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, age: " 75 - 80" })} type="radio" name="age" className="custom-control-input" id="75-80" />
                                        <label className="custom-control-label" htmlFor="75-80">
                                            75 - 80
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, age: "80+" })} type="radio" name="age" className="custom-control-input" id="80+" />
                                        <label className="custom-control-label" htmlFor="80+">
                                            80+
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Skin Type and Visual Risk Areas</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Skin*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, skin: "Healthy" })} type="radio" name="skin" className="custom-control-input" id="Healthy" />
                                        <label className="custom-control-label" htmlFor="Healthy">
                                            Healthy
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, skin: " Tissue Paper" })} type="radio" name="skin" className="custom-control-input" id="Tissue Paper" />
                                        <label className="custom-control-label" htmlFor="Tissue Paper">
                                            Tissue Paper
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, skin: "Dry" })} type="radio" name="skin" className="custom-control-input" id="Dry" />
                                        <label className="custom-control-label" htmlFor="Dry">
                                            Dry
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, skin: " Oedematous" })} type="radio" name="skin" className="custom-control-input" id="Oedematous" />
                                        <label className="custom-control-label" htmlFor="Oedematous">
                                            Oedematous
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, skin: "Clammy, Pyrexia" })} type="radio" name="skin" className="custom-control-input" id="Clammy, Pyrexia" />
                                        <label className="custom-control-label" htmlFor="Clammy, Pyrexia">
                                            Clammy, Pyrexia
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, skin: "Discoloured Grade 1" })}
                                            type="radio"
                                            name="skin"
                                            className="custom-control-input"
                                            id="Discoloured Grade 1 "
                                        />
                                        <label className="custom-control-label" htmlFor="Discoloured Grade 1 ">
                                            Discoloured Grade 1
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, skin: "Broken/Spots Grade 2-4" })}
                                            type="radio"
                                            name="skin"
                                            className="custom-control-input"
                                            id="Broken/Spots Grade 2-4"
                                        />
                                        <label className="custom-control-label" htmlFor="Broken/Spots Grade 2-4">
                                            Broken/Spots Grade 2-4
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Build/Weight for Height</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>BMI range*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, bmiRange: " 20 - 24.9 (Average)" })} type="radio" name="bmi" className="custom-control-input" id="20 - 24.9" />
                                        <label className="custom-control-label" htmlFor="20 - 24.9">
                                            20 - 24.9 (Average)
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, bmiRange: "25 - 29.9 (Above Average)" })}
                                            type="radio"
                                            name="bmi"
                                            className="custom-control-input"
                                            id="25 - 29.9 (Above Average)"
                                        />
                                        <label className="custom-control-label" htmlFor="25 - 29.9 (Above Average)">
                                            25 - 29.9 (Above Average)
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, bmiRange: "> 30 (Obese)" })} type="radio" name="bmi" className="custom-control-input" id="> 30 (Obese)" />
                                        <label className="custom-control-label" htmlFor="> 30 (Obese)">
                                            > 30 (Obese)
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, bmiRange: "< 20 (Below Average)" })}
                                            type="radio"
                                            name="bmi"
                                            className="custom-control-input"
                                            id="< 20 (Below Average)"
                                        />
                                        <label className="custom-control-label" htmlFor="< 20 (Below Average)">
                                            &#60; 20 (Below Average)
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Malnutrition Screening Tool</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>A - Has the Patient lost weight recently?*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        a: "Yes",
                                                    },
                                                })
                                            }
                                            type="radio"
                                            name="mal"
                                            className="custom-control-input"
                                            id="mal-yes"
                                        />
                                        <label className="custom-control-label" htmlFor="mal-yes">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        a: "No",
                                                    },
                                                })
                                            }
                                            type="radio"
                                            name="mal"
                                            className="custom-control-input"
                                            id="mal-no"
                                        />
                                        <label className="custom-control-label" htmlFor="mal-no">
                                            No
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        a: "Unsure",
                                                    },
                                                })
                                            }
                                            type="radio"
                                            name="mal"
                                            className="custom-control-input"
                                            id="mal-unsure"
                                        />
                                        <label className="custom-control-label" htmlFor="mal-unsure">
                                            Unsure
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>B - Weight Loss*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="col-6">
                                        <Select
                                            options={[
                                                { value: "0", label: "0.5 - 5KG" },
                                                { value: "1", label: "5 - 10KG" },
                                                { value: "2", label: "10 - 15KG" },
                                                { value: "3", label: "> 15KG" },
                                                { value: "4", label: "Unsure" },
                                            ]}
                                            valueField="value"
                                            labelField="label"
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        b: items[0].label,
                                                    },
                                                })
                                            }
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>C - Patient eating poorly or lack of Appetite?*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        c: "Yes",
                                                    },
                                                })
                                            }
                                            type="radio"
                                            name="appetite"
                                            className="custom-control-input"
                                            id="appetite-yes"
                                        />
                                        <label className="custom-control-label" htmlFor="appetite-yes">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    malNutrition: {
                                                        ...model.malNutrition,
                                                        c: "No",
                                                    },
                                                })
                                            }
                                            type="radio"
                                            name="appetite"
                                            className="custom-control-input"
                                            id="appetite-no"
                                        />
                                        <label className="custom-control-label" htmlFor="appetite-no">
                                            No
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="3">Nutrition Score if > 2 refer for Nutrition Assessment/Intervention</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Continence</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Continence Score*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    continence: "Complete / Catheterised",
                                                })
                                            }
                                            type="radio"
                                            name="Continence"
                                            className="custom-control-input"
                                            id="Complete / Catheterised"
                                        />
                                        <label className="custom-control-label" htmlFor="Complete / Catheterised">
                                            Complete / Catheterised
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    continence: " Urine Incontinence",
                                                })
                                            }
                                            type="radio"
                                            name="Continence"
                                            className="custom-control-input"
                                            id="Urine Incontinence"
                                        />
                                        <label className="custom-control-label" htmlFor="Urine Incontinence">
                                            Urine Incontinence
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    continence: "Faecal Incontinence",
                                                })
                                            }
                                            type="radio"
                                            name="Continence"
                                            className="custom-control-input"
                                            id="Faecal Incontinence"
                                        />
                                        <label className="custom-control-label" htmlFor="Faecal Incontinence">
                                            Faecal Incontinence
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    continence: "Urine + Faecal Incontinence",
                                                })
                                            }
                                            type="radio"
                                            name="Continence"
                                            className="custom-control-input"
                                            id="Urine_Faecal Incontinence"
                                        />
                                        <label className="custom-control-label" htmlFor="Urine_Faecal Incontinence">
                                            Urine + Faecal Incontinence
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Mobility</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Mobility Score*</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, mobility: "Fully" })} type="radio" name="Mobility" className="custom-control-input" id="Fully" />
                                        <label className="custom-control-label" htmlFor="Fully">
                                            Fully
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, mobility: "Restless / Fidgety" })}
                                            type="radio"
                                            name="Mobility"
                                            className="custom-control-input"
                                            id="Restless / Fidgety"
                                        />
                                        <label className="custom-control-label" htmlFor="Restless / Fidgety">
                                            Restless / Fidgety
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, mobility: "Apathetic" })} type="radio" name="Mobility" className="custom-control-input" id="Apathetic" />
                                        <label className="custom-control-label" htmlFor="Apathetic">
                                            Apathetic
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input onChange={() => setModel({ ...model, mobility: "Restricted" })} type="radio" name="Mobility" className="custom-control-input" id="restricted" />
                                        <label className="custom-control-label" htmlFor="restricted">
                                            Restricted
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, mobility: "Bed bound e.g. Traction" })}
                                            type="radio"
                                            name="Mobility"
                                            className="custom-control-input"
                                            id="bed-mobility"
                                        />
                                        <label className="custom-control-label" htmlFor="bed-mobility">
                                            Bed bound e.g. Traction
                                        </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                            onChange={() => setModel({ ...model, mobility: " Chair bound e.g. Wheelchair" })}
                                            type="radio"
                                            name="Mobility"
                                            className="custom-control-input"
                                            id="chair-mobility"
                                        />
                                        <label className="custom-control-label" htmlFor="chair-mobility">
                                            Chair bound e.g. Wheelchair
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Special Risk</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Tissue Malnutrition</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="col-6">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    specialRisk: {
                                                        ...model.specialRisk,
                                                        tissue: items[0].label,
                                                    },
                                                })
                                            }
                                            options={options.tissue}
                                            valueField="value"
                                            labelField="label"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Neurological Deficit</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <table className="table bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div class="custom-control custom-checkbox">
                                                        <input onChange={() => onMoreChange("Diabetes, MS, CVA")} type="checkbox" class="custom-control-input" id="t-Diabetes" />
                                                        <label class="custom-control-label" htmlFor="t-Diabetes">
                                                            Diabetes, MS, CVA
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="custom-control custom-checkbox">
                                                        <input onChange={() => onMoreChange(" Motor/Sensory")} type="checkbox" class="custom-control-input" id="t-motor" />
                                                        <label class="custom-control-label" htmlFor="t-motor">
                                                            Motor/Sensory
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="custom-control custom-checkbox">
                                                        <input onChange={() => onMoreChange("Paraplegia (Max of 6)")} type="checkbox" class="custom-control-input" id="t-Paraplegia" />
                                                        <label class="custom-control-label" htmlFor="t-Paraplegia">
                                                            Paraplegia (Max of 6)
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td></td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Major Surgery or Trauma</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div className="col-md-6">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    specialRisk: {
                                                        ...model.specialRisk,
                                                        major: items[0].label,
                                                    },
                                                })
                                            }
                                            options={options.major}
                                            valueField="value"
                                            labelField="label"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Medication</strong>
                                </td>
                                <td style={{ width: "75%" }}>
                                    <div class="custom-control custom-checkbox">
                                        <input
                                            onChange={() =>
                                                setModel({
                                                    ...model,
                                                    specialRisk: {
                                                        ...model.specialRisk,
                                                        medication: "Cytotoxics, Long term/High Dose Steroids, Anti-Inflammatory -- Max of 4",
                                                    },
                                                })
                                            }
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="m-Cytotoxics"
                                        />
                                        <label class="custom-control-label" htmlFor="m-Cytotoxics">
                                            Cytotoxics, Long term/High Dose Steroids, Anti-Inflammatory -- Max of 4
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Total Score</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                    <strong>Guidance</strong>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "78%" }}>
                                    <span>10+ At Risk, 15+ High Risk, 20+ Very High Risk</span>
                                </td>
                                <td>
                                    <div style={{ fontSize: "2em", fontWeight: "400" }}>0</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-4">
                        <div className="custom-control custom-checkbox">
                            <input defaultChecked={confirm} type="checkbox" onChange={() => setConfirm(!confirm)} id="confirm" name="customRadioInline1" className="custom-control-input" />
                            <label className="custom-control-label" htmlFor="confirm">
                                Confirm on creation
                            </label>
                        </div>
                    </div>
                    <div className="col-12 text-center pt-5 pb-5">
                        <button type="button" onClick={() => onCancel()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle">
                            <i className="material-icons text-danger">close</i> Close
                        </button>
                        <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle">
                            Submit Assessment <i className="material-icons">arrow_right_alt</i>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};
export default NewWaterLow;
